import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const TOP_METRICS = [{
  value: '+200',
  label: 'Clases listas'
}, {
  value: '+5000',
  label: 'Alumnas satisfechas'
}, {
  value: '3.800+',
  label: 'Horas ahorradas'
}, {
  value: '99%',
  label: 'Lo recomiendan'
}];
const BEFORE = ['Horas planificando cada clase', 'Clases repetitivas', 'Sin profundidad filosófica', 'No saber qué cobrar', 'Alumnos que se van'];
const AFTER = ['5 minutos de repaso', 'Clases con variedad', 'Tema filosófico cada semana', 'Precios claros y confianza', 'Comunidad fiel'];
const BOTTOM_STATS = [{
  value: '+200',
  label: 'Clases'
}, {
  value: '12',
  label: 'Tomos'
}, {
  value: '100%',
  label: 'Descargable'
}];
export function ImpactStats() {
  return <section className="bg-hueso" data-id="element-119">
      {/* Top metrics bar */}
      <div className="bg-white border-b border-gray-100" data-id="element-120">
        <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 divide-x divide-gray-200" data-id="element-121">
          {TOP_METRICS.map((metric, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} className="py-8 px-4 text-center" data-id="element-122">
              <div className="font-serif text-3xl md:text-5xl font-bold text-oscuro mb-1" data-id="element-123">
                {metric.value}
              </div>
              <div className="text-[11px] md:text-sm uppercase tracking-widest text-gray-500 font-medium" data-id="element-124">
                {metric.label}
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Main content */}
      <div className="max-w-6xl mx-auto px-4 py-16 md:py-24" data-id="element-125">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-126">
          {/* Left: headline + highlight card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-127">
            <h2 className="font-serif text-4xl md:text-6xl font-bold text-oscuro leading-[1.05] mb-8" data-id="element-128">
              De una profesora sobrecargada a una{' '}
              <span className="italic text-salvia" data-id="element-129">guía inspirada.</span>
            </h2>

            <div className="bg-white rounded-3xl shadow-soft p-6 md:p-8 flex items-center gap-5 max-w-md" data-id="element-130">
              <span className="font-serif text-5xl md:text-6xl font-bold text-terracota leading-none" data-id="element-131">
                3.800+
              </span>
              <span className="text-gray-600 text-sm md:text-base leading-snug" data-id="element-132">
                horas ahorradas al año en planificación.
              </span>
            </div>
          </motion.div>

          {/* Right: before / after card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="rounded-3xl border border-gray-100 shadow-soft overflow-hidden grid grid-cols-2" data-id="element-133">
            {/* Before */}
            <div className="bg-white p-6 md:p-8" data-id="element-134">
              <div className="flex items-center gap-2 mb-6" data-id="element-135">
                <span className="w-6 h-6 rounded-full bg-terracota/10 text-terracota flex items-center justify-center" data-id="element-136">
                  <X size={13} strokeWidth={3} data-id="element-137" />
                </span>
                <span className="text-xs md:text-sm font-bold uppercase tracking-widest text-terracota" data-id="element-138">
                  Antes
                </span>
              </div>
              <ul className="space-y-4" data-id="element-139">
                {BEFORE.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-140">
                    <X size={16} className="text-terracota/60 flex-shrink-0 mt-0.5" data-id="element-141" />
                    <span className="text-gray-600 text-sm md:text-[15px] leading-snug" data-id="element-142">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* After */}
            <div className="bg-salvia-light/60 p-6 md:p-8" data-id="element-143">
              <div className="flex items-center gap-2 mb-6" data-id="element-144">
                <span className="w-6 h-6 rounded-full bg-salvia/20 text-salvia flex items-center justify-center" data-id="element-145">
                  <Check size={13} strokeWidth={3} data-id="element-146" />
                </span>
                <span className="text-xs md:text-sm font-bold uppercase tracking-widest text-salvia" data-id="element-147">
                  Con Yoga 360
                </span>
              </div>
              <ul className="space-y-4" data-id="element-148">
                {AFTER.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-149">
                    <Check size={16} className="text-salvia flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-150" />
                    <span className="text-oscuro font-medium text-sm md:text-[15px] leading-snug" data-id="element-151">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>

        {/* Bottom stat cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mt-12 md:mt-16 max-w-4xl mx-auto" data-id="element-152">
          {BOTTOM_STATS.map((stat, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl shadow-soft py-8 px-4 text-center" data-id="element-153">
              <div className="font-serif text-4xl md:text-5xl font-bold text-salvia mb-1" data-id="element-154">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm uppercase tracking-widest text-gray-500 font-medium" data-id="element-155">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}